/**
 * Form rule for an allowance's currency: required once the allowance has a
 * calculation method (is in use), optional while it has none.
 *
 * @param {Array<string>} methodKeys - Form path of the allowance's method.
 * @param {string} message - Error text.
 * @returns {Function} antd rule
 */
export const allowanceCurrencyRule =
  (methodKeys, message) =>
  ({ getFieldValue }) => ({
    validator: (_, value) =>
      getFieldValue(methodKeys) && !value
        ? Promise.reject(new Error(message))
        : Promise.resolve(),
  });
